// ============================================================
// lib/android.ts
//
// STASH is iPhone-only for now. Android visitors see a notice
// and the Android wait list in place of App Store badges. Copy
// matches the brand site (brand-site/src/lib/android.ts).
// ============================================================
import { useState } from 'react';

export const ANDROID_HEADLINE = 'STASH is iPhone-only right now but Android is on our roadmap';
export const ANDROID_CTA = 'Tell me when STASH is on Android';
export const ANDROID_OPT_IN =
  'By submitting, you wish to be contacted by text or email when STASH is available on Android. We’ll note your approximate area (from your connection) to plan where to launch, and won’t share or use your info for anything else.';

/** DB-IP City Lite (CC BY 4.0) supplies the approximate location; its license asks for this link. */
export const DBIP_ATTRIBUTION = { label: 'IP Geolocation by DB-IP', url: 'https://db-ip.com' } as const;

/** The browser's IANA time zone (e.g. America/Chicago), or undefined if unavailable. */
export function browserTimeZone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}

/** Stored as androidWaitListers.referralCode to say which screen a sign-up came from. */
export const ANDROID_REFERRAL = {
  home: 'app.stash-app.com/home',
  login: 'app.stash-app.com/login',
} as const;

/** UA Client Hints platform (Chromium) first, then the user-agent string (all browsers). */
export function isAndroidDevice(nav: { userAgent: string; platform?: string | undefined }): boolean {
  return nav.platform === 'Android' || /Android/i.test(nav.userAgent);
}

/** Whether this browser is on Android; read once, on first render. */
export function useIsAndroid(): boolean {
  const [android] = useState(() => {
    if (typeof navigator === 'undefined') return false;
    // userAgentData (UA Client Hints) exists only in Chromium browsers.
    const hints = (navigator as { userAgentData?: { platform?: string } }).userAgentData;
    return isAndroidDevice({ userAgent: navigator.userAgent, platform: hints?.platform });
  });
  return android;
}
